<div class="main-container mg-left mg-right">
    <div class="search-content">
        @if (showShortHint() && shortHintText()) {
            <div class="mb-15 font-medium hint">
                {{ shortHintText() }}
            </div>
        }

        @if (showEmpty()) {
            <div class="mb-15 font-medium" data-testid="search_empty-message">{{ 'search.noresults.message' | transloco }}</div>
        }

        @if (showRecommendations() && recommendationsItems().length) {
            <div class="title font-xlarge">{{ 'home.tile.recommendations.title' | transloco }}</div>
            <asset-grid
                class="item-grid"
                [items]="recommendationsItems()"
                displayFormat="portrait"
                data-testid="search_recommendations-grid"
                (itemClick)="onItemClick($event)">
            </asset-grid>
        }

        @if (hasMinQuery() && searchType() === SearchTypes.Grid) {
            <!-- Skeleton while the search round-trip runs — the request can take a while
                 and stale/blank results otherwise give no hint anything is happening. -->
            @if (loading()) {
                <catalogue-row-skeleton />
                <catalogue-row-skeleton [showTitle]="false" />
            } @else if (hasResults()) {
                <div class="title">{{ 'videostore.tab.search_result' | transloco }}</div>
                <asset-grid
                    class="item-grid"
                    [items]="results()"
                    displayFormat="landscape"
                    data-testid="search_item-grid"
                    [cardTestId]="'search_result'"
                    (itemClick)="onItemClick($event)">
                </asset-grid>
            }
        }
    </div>
</div>

@if (hasMinQuery() && searchType() === SearchTypes.Categorized) {
    <div class="catalogues">
        @if (loading()) {
            <catalogue-row-skeleton />
            <catalogue-row-skeleton />
        } @else {
            @for (section of categorized(); track section.type) {
                <asset-list
                    [title]="section.title"
                    [items]="section.items"
                    displayFormat="landscape"
                    size="small"
                    [cardTestId]="'search_result'"
                    (itemClick)="onItemClick($event)">
                </asset-list>
            }
        }
    </div>
}
